import React from "react";

import { cn } from "lib/utils";

import { SkeletonBlock, SkeletonText } from "./SkeletonPrimitives";

type StepsSkeletonProps = {
  steps?: number;
  orientation?: "horizontal" | "vertical";
  className?: string;
};

const StepsSkeleton = ({
  steps = 4,
  orientation = "horizontal",
  className,
}: StepsSkeletonProps) => {
  const isHorizontal = orientation === "horizontal";

  return (
    <div
      className={cn(
        "flex gap-4",
        isHorizontal ? "flex-row" : "flex-col",
        className,
      )}
      aria-hidden
      data-testid="steps-skeleton"
    >
      {Array.from({ length: steps }).map((_, index) => (
        <div
          key={`step-${index}`}
          className={cn(
            "flex items-center gap-3 rounded-full border border-slate-200/70 bg-white/95 px-4 py-2",
            !isHorizontal && "w-full",
          )}
        >
          <SkeletonBlock className="size-6 rounded-full" />
          <SkeletonText className="h-4 w-28" />
        </div>
      ))}
    </div>
  );
};

export default StepsSkeleton;
